import React from 'react';
import { useHistory } from 'react-router-dom';
import { BrandImage, BrandImageProps } from './BuyNowDetails';
import { Btn } from 'components/btn/Btn';
import { Routes } from 'routes';
import { useRootSelector } from 'rootStore';
import {
    buyNowFlow,
    selectBuyNowPurchaseSuccessData,
} from 'common/features/store/duck/ui/buy-now-flow';
import { round } from 'common/utils/utils';
import { useDispatch } from 'react-redux';

interface BuyNowSuccessScreenProps extends BrandImageProps {}

export const BuyNowSuccessScreen = (props: BuyNowSuccessScreenProps) => {
    const { subtotal = 0, earnings = 0 } = useRootSelector(selectBuyNowPurchaseSuccessData) || {};
    const history = useHistory();
    const dispatch = useDispatch<any>();

    const goToWallet = () => {
        history.push(Routes.WalletMyCards);
        dispatch(buyNowFlow.resetState(null));
    };

    return (
        <div className="text-center">
            <BrandImage imageUrl={props.imageUrl} isOnBonus={props.isOnBonus} />
            <p className="w-full sm:w-64 mt-8 mb-3 sm:mb-5 mx-auto text-brand-dark text-22px sm:text-29px font-semibold">
                Your ${round(subtotal, 2).toFixed(2)} eGift Card is Ready
            </p>
            <p className="mb-3 sm:mb-5 text-success text-xl sm:text-22px font-semibold">
                You earned ${round(earnings, 2).toFixed(2)}
            </p>
            <p className="text-base text-grey-1 mx-5">
                An order confirmation has been sent to your email.
            </p>
            <br />
            <Btn className="mb-5" onClick={goToWallet}>
                Go to Wallet
            </Btn>
        </div>
    );
};
